'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = require('react-transition-group/TransitionGroup');

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _cssAnimationGroupChild = require('./css-animation-group-child');

var _cssAnimationGroupChild2 = _interopRequireDefault(_cssAnimationGroupChild);

var _normalizeTime = require('./lib/normalize-time');

var _normalizeTime2 = _interopRequireDefault(_normalizeTime);

var _propTypes3 = require('./lib/prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CSSAnimationGroup = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CSSAnimationGroup, _Component);

  function CSSAnimationGroup() {
    (0, _classCallCheck3.default)(this, CSSAnimationGroup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CSSAnimationGroup.__proto__ || (0, _getPrototypeOf2.default)(CSSAnimationGroup)).call(this));

    _this.childFactory = _this.childFactory.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CSSAnimationGroup, [{
    key: 'childFactory',
    value: function childFactory(child, index) {
      var _props = this.props,
          enterAnimation = _props.enterAnimation,
          enterDelay = _props.enterDelay,
          enterDirection = _props.enterDirection,
          enterDuration = _props.enterDuration,
          enterFillMode = _props.enterFillMode,
          enterIterationCount = _props.enterIterationCount,
          enterTimingFunction = _props.enterTimingFunction,
          leaveAnimation = _props.leaveAnimation,
          leaveDelay = _props.leaveDelay,
          leaveDirection = _props.leaveDirection,
          leaveDuration = _props.leaveDuration,
          leaveFillMode = _props.leaveFillMode,
          leaveIterationCount = _props.leaveIterationCount,
          leaveTimingFunction = _props.leaveTimingFunction,
          enterOnAppear = _props.enterOnAppear;

      return _react2.default.createElement(
        _cssAnimationGroupChild2.default,
        {
          key: index,
          enterAnimation: {
            delay: (0, _normalizeTime2.default)(enterDelay),
            direction: enterDirection,
            duration: (0, _normalizeTime2.default)(enterDuration),
            fillMode: enterFillMode,
            iterationCount: enterIterationCount,
            name: enterAnimation,
            timingFunction: enterTimingFunction
          },
          leaveAnimation: {
            delay: (0, _normalizeTime2.default)(leaveDelay),
            direction: leaveDirection,
            duration: (0, _normalizeTime2.default)(leaveDuration),
            fillMode: leaveFillMode,
            iterationCount: leaveIterationCount,
            name: leaveAnimation,
            timingFunction: leaveTimingFunction
          },
          enterOnAppear: enterOnAppear
        },
        child
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          enterAnimation = _props2.enterAnimation,
          enterDelay = _props2.enterDelay,
          enterDirection = _props2.enterDirection,
          enterDuration = _props2.enterDuration,
          enterFillMode = _props2.enterFillMode,
          enterIterationCount = _props2.enterIterationCount,
          enterTimingFunction = _props2.enterTimingFunction,
          leaveAnimation = _props2.leaveAnimation,
          leaveDelay = _props2.leaveDelay,
          leaveDirection = _props2.leaveDirection,
          leaveDuration = _props2.leaveDuration,
          leaveFillMode = _props2.leaveFillMode,
          leaveIterationCount = _props2.leaveIterationCount,
          leaveTimingFunction = _props2.leaveTimingFunction,
          enterOnAppear = _props2.enterOnAppear,
          restProps = (0, _objectWithoutProperties3.default)(_props2, ['component', 'enterAnimation', 'enterDelay', 'enterDirection', 'enterDuration', 'enterFillMode', 'enterIterationCount', 'enterTimingFunction', 'leaveAnimation', 'leaveDelay', 'leaveDirection', 'leaveDuration', 'leaveFillMode', 'leaveIterationCount', 'leaveTimingFunction', 'enterOnAppear']);

      return _react2.default.createElement(_TransitionGroup2.default, (0, _extends3.default)({}, restProps, {
        component: component,
        childFactory: this.childFactory
      }));
    }
  }]);
  return CSSAnimationGroup;
}(_react.Component), _class.defaultProps = {
  component: 'span',
  enterAnimation: '',
  enterDelay: 0,
  enterDirection: 'normal',
  enterDuration: 0,
  enterFillMode: 'none',
  enterIterationCount: 1,
  enterTimingFunction: 'ease',
  leaveAnimation: '',
  leaveDelay: 0,
  leaveDirection: 'normal',
  leaveDuration: 0,
  leaveFillMode: 'none',
  leaveIterationCount: 1,
  leaveTimingFunction: 'ease',
  enterOnAppear: false
}, _temp);
process.env.NODE_ENV !== "production" ? CSSAnimationGroup.propTypes = {
  component: _propTypes3.componentType,
  enterAnimation: _propTypes2.default.string,
  enterDelay: _propTypes3.timeType,
  enterDirection: _propTypes3.directionType,
  enterDuration: _propTypes3.timeType,
  enterFillMode: _propTypes3.fillModeType,
  enterIterationCount: _propTypes2.default.number,
  enterTimingFunction: _propTypes2.default.string,
  leaveAnimation: _propTypes2.default.string,
  leaveDelay: _propTypes3.timeType,
  leaveDirection: _propTypes3.directionType,
  leaveDuration: _propTypes3.timeType,
  leaveFillMode: _propTypes3.fillModeType,
  leaveIterationCount: _propTypes2.default.number,
  leaveTimingFunction: _propTypes2.default.string,
  enterOnAppear: _propTypes2.default.bool
} : void 0;
exports.default = CSSAnimationGroup;